import { createFileRoute, redirect } from '@tanstack/react-router'
import { Outlet } from '@/libs/router'
import { session$ } from '@/features/auth/store'
import { resolveAuthRedirect } from '@/features/auth/domain/auth'
import { Sidebar } from '@/features/shell/ui/sidebar'
import { Header } from '@/features/shell/ui/header'
import { UserPreferencesProvider } from '@/features/preferences/ui/user-preferences-provider'
import { GlobalSheets } from '@/components/global-sheets'
import { useUI } from '@/features/ui/hooks/use-ui'
import { useInitPermissions } from '@/features/permissions/hooks/use-permission'
import { useInitNotifications } from '@/features/notifications/hooks/use-init-notifications'

const DevUserSwitcher = import.meta.env.DEV
	? (await import('@/features/auth/ui/dev-user-switcher')).DevUserSwitcher
	: null

export const Route = createFileRoute('/_authenticated')({
	beforeLoad: () => {
		const to = resolveAuthRedirect(session$.get(), '/')
		if (to) throw redirect({ to })
	},
	component: AuthenticatedLayout,
})

const GlobalHooks = () => {
	useUI()
	useInitPermissions()
	useInitNotifications()
	return null
}

function AuthenticatedLayout() {
	return (
		<UserPreferencesProvider>
			<GlobalHooks />
			<div className='relative grid grid-cols-[70px_1fr]'>
				<Sidebar />
				<div className='pb-4 w-full'>
					<Header />
					<Outlet />
				</div>
			</div>
			{DevUserSwitcher && <DevUserSwitcher />}
			<GlobalSheets />
		</UserPreferencesProvider>
	)
}
